import { createRoot } from "react-dom/client";
import { initOfflineSupport } from "@/lib/offline";
import { clearCacheOnUpdate } from "@/lib/cache";
import { reportWebVitals } from "@/lib/reportWebVitals";
import { registerServiceWorkerWhenIdle } from "@/lib/registerSw";
import App from "./App.tsx";
import "./index.css";

// Clear cache if app version changed (prevents stale content)
clearCacheOnUpdate();

// Initialize offline support (cache + queue) - defer non-critical initialization
setTimeout(() => {
  initOfflineSupport();
}, 0);

if (import.meta.env.PROD) {
  registerServiceWorkerWhenIdle();
}

createRoot(document.getElementById("root")!).render(<App />);

// Core Web Vitals — register after paint (tiny observers; helps validate LCP/CLS/INP in prod)
if (typeof window !== "undefined") {
  queueMicrotask(() => reportWebVitals());
}
